import React from "react";
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";
import {
  formatFileSize,
  getDocumentTypeLabel,
  handleImagePreviewError,
  isImageDocument,
  isPdfDocument,
} from "./document-utils";

const getDocumentIcon = (doc) =>
  isImageDocument(doc)
    ? "fa-file-image-o"
    : isPdfDocument(doc)
      ? "fa-file-pdf-o"
      : "fa-file-o";

const DocumentsGalleryModal = ({
  isOpen,
  closeDocumentsModal,
  activeDocument,
  activeDocumentIndex,
  documents,
  removeDocumentAt,
  goToPreviousDocument,
  goToNextDocument,
  setActiveDocumentIndex,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={closeDocumentsModal}
    size="xl"
    centered
    className="dhn-document-viewer-modal"
  >
    <ModalHeader
      toggle={closeDocumentsModal}
      iconClass="fa-files-o"
      description="Galería de documentos"
      subtitle={
        activeDocument
          ? `Revise los documentos adjuntos (${activeDocumentIndex + 1} de ${documents.length}).`
          : "Sin documentos"
      }
    />
    <ModalBody className="dhn-document-viewer-modal__body">
      {!!activeDocument && (
        <div className="dhn-document-viewer">
          <Card className="dhn-document-viewer__toolbar mb-0">
            <CardBody>
              <div className="dhn-document-viewer__file-info">
                <span className="dhn-document-viewer__file-icon">
                  <i className={`fa ${getDocumentIcon(activeDocument)}`} aria-hidden="true" />
                </span>
                <div className="dhn-document-viewer__file-copy">
                  <strong title={activeDocument.name}>{activeDocument.name}</strong>
                  <span>
                    {getDocumentTypeLabel(activeDocument)}
                    <Badge color="secondary" pill className="ml-2">
                      {formatFileSize(activeDocument.size)}
                    </Badge>
                  </span>
                </div>
              </div>
              <Button
                type="button"
                color="danger"
                size="sm"
                className="btn-color-danger"
                onClick={() => removeDocumentAt(activeDocumentIndex)}
                title="Borrar actual"
                aria-label="Borrar actual"
              >
                <i className="fa fa-trash mr-1" aria-hidden="true" />
                Borrar
              </Button>
            </CardBody>
          </Card>

          <div className="dhn-document-viewer__stage">
            <Button
              type="button"
              color="primary"
              className="btn-color-primary dhn-document-viewer__nav dhn-document-viewer__nav--previous"
              onClick={goToPreviousDocument}
              title="Documento anterior"
              aria-label="Documento anterior"
            >
              <i className="fa fa-chevron-left" aria-hidden="true" />
            </Button>

            <div className="dhn-document-viewer__preview">
              {activeDocument.previewUrl && isImageDocument(activeDocument) && (
                <>
                  <img
                    src={activeDocument.previewUrl}
                    alt={activeDocument.name}
                    onError={handleImagePreviewError}
                  />
                  <div className="dhn-document-viewer__empty" hidden>
                    <span className="dhn-document-viewer__empty-icon is-danger">
                      <i className="fa fa-file-image-o" aria-hidden="true" />
                    </span>
                    <strong>Vista previa no disponible</strong>
                    <span>No fue posible mostrar la imagen.</span>
                  </div>
                </>
              )}
              {activeDocument.previewUrl && isPdfDocument(activeDocument) && (
                <iframe title={activeDocument.name} src={activeDocument.previewUrl} />
              )}
              {!activeDocument.previewUrl && (
                <div className="dhn-document-viewer__empty">
                  <span className="dhn-document-viewer__empty-icon">
                    <i className="fa fa-file-o" aria-hidden="true" />
                  </span>
                  <strong>Vista previa no disponible</strong>
                  <span>No hay previsualizacion para este archivo.</span>
                </div>
              )}
            </div>

            <Button
              type="button"
              color="primary"
              className="btn-color-primary dhn-document-viewer__nav dhn-document-viewer__nav--next"
              onClick={goToNextDocument}
              title="Documento siguiente"
              aria-label="Documento siguiente"
            >
              <i className="fa fa-chevron-right" aria-hidden="true" />
            </Button>
          </div>

          <div className="dhn-document-viewer__thumbs">
            {documents.map((doc, idx) => (
              <ButtonGroup key={`${doc.name}-${doc.size}-${idx}`}>
                <Button
                  type="button"
                  color={idx === activeDocumentIndex ? "primary" : "secondary"}
                  className={`dhn-document-viewer__thumb ${idx === activeDocumentIndex ? "is-active" : ""}`}
                  onClick={() => setActiveDocumentIndex(idx)}
                  title={doc.name}
                >
                  <i className={`fa ${getDocumentIcon(doc)}`} aria-hidden="true" />
                  <span>{doc.name}</span>
                </Button>
                <Button
                  type="button"
                  color="danger"
                  className="btn-color-danger"
                  onClick={() => removeDocumentAt(idx)}
                  title="Borrar"
                  aria-label={`Borrar ${doc.name}`}
                >
                  <i className="fa fa-times" aria-hidden="true" />
                </Button>
              </ButtonGroup>
            ))}
          </div>
        </div>
      )}
    </ModalBody>
    <ModalFooter>
      <Button
        type="button"
        color="danger"
        className="btn-color-danger"
        onClick={closeDocumentsModal}
      >
        <i className="fa fa-times-circle mr-2" aria-hidden="true" />
        Cerrar
      </Button>
    </ModalFooter>
  </Modal>
);

export default DocumentsGalleryModal;
